<template>
  <div>
    <div class="row">
      <ticket-counter-lifetime ref="lifetime"></ticket-counter-lifetime>

      <ticket-counter-today ref="today"></ticket-counter-today>

      <ticket-counter-lifetime-resolved
        ref="resolved"
      ></ticket-counter-lifetime-resolved>

      <ticket-counter-general ref="general"></ticket-counter-general>
    </div>
    <div class="row card">
      <div class="col-md-12 card-body">
          <semi-pie-chart></semi-pie-chart>
      </div>
    </div>
    <div class="row card">
      <div class="col-md-12 card-body">
         <module-wise-bar-chart></module-wise-bar-chart>
      </div>
    </div>
  </div>
</template>

<script>
import TicketCounterLifetime from "./tickets/TicketCounterLifetime";
import TicketCounterToday from "./tickets/TicketCounterToday";
import TicketCounterTotalResolved from "./tickets/TicketCounterLifetimeResolved";
import TicketCounterGeneral from "./tickets/TicketCounterGeneral";

import SemiPieChart from './SemiPieChart';
import ModuleWiseBarChart from './ModuleWiseBarChart';
export default {
  name: "dashboard-ticket",
  components: {
    "ticket-counter-lifetime": TicketCounterLifetime,
    "ticket-counter-today": TicketCounterToday,
    "ticket-counter-lifetime-resolved": TicketCounterTotalResolved,
    "ticket-counter-general": TicketCounterGeneral,
    'semi-pie-chart' : SemiPieChart,
    'module-wise-bar-chart' : ModuleWiseBarChart,
  },
  data() {
    return {};
  },
  methods: {
    ticketCounters() {
      axios
        .get("dashboard/counters")
        .then((response) => {
          this.$refs.lifetime.LifetimeTickets = response.data.lifetime;

          this.$refs.today.TicketToday = response.data.todayTickets;

          this.$refs.resolved.TicketResolved = response.data.resolved;

          this.$refs.general.GeneralTickets = response.data.general;
        //   console.log(response.data);
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
  },
  mounted() {
    this.ticketCounters();
    
  },
  
};
</script>

<style lang="scss" scoped>
.semiPieChart{
    width: 100%;
    height: 500px;
}
</style>